import React from 'react';
import { cn } from '@/lib/utils';

type Props = {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
};

const ImageWithOverlayBorder: React.FC<Props> = ({
  src,
  alt = '',
  width = 72,
  height = 72,
  className,
}) => {
  return (
    <div
      className={cn('relative inline-block overflow-hidden rounded', className)}
      style={{ width, height }}
    >
      <img src={src} alt={alt} className="block size-full rounded" />
      <div className="pointer-events-none absolute inset-0 rounded border border-border/40" />
    </div>
  );
};

export default ImageWithOverlayBorder;
